import styled from 'styled-components';

export default styled.div`
  display: flex;
  margin-bottom: 10px;
  
  * {
    margin-right: 10px;
    margin-bottom: 10px;
    &:last-of-type {
      margin-right: 0;
    }
  }
`;